import { LOADING, ActionSource } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { asBoolean } from "common/components/component-helpers";
import ToggleIconOverlayView from "../ui/views/toggle-icon-overlay/toggle-icon-overlay-view";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";

// FIXME: Whyyyyy is this here?
export function withFigmaPreview(f: any, figmaPreviewId: string) {
    f.story = {
        parameters: {
            figmaPreviewId,
        },
    };

    return f;
}

export const ToggleIconOverlayMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[valuePV, onChangePV], [valueProducer]] = useForceValueProducers(getValueProducers, force, ctx);
    const { onClick: onChangeCB } = useOnClickFromAction(onChangePV, ActionSource.None, ctx, env);

    if (valuePV === LOADING) {
        return env.renderProgress();
    }

    const onChange = (newValue: boolean): void => {
        if (valueProducer === undefined) return;

        valueProducer.set(newValue);
        if (onChangeCB !== undefined) {
            void onChangeCB(undefined);
        }
    };

    const checked = asBoolean(valuePV);

    return (
        <div>
            <ToggleIconOverlayView
                data-test="app-toggle-icon-overlay"
                onClick={e => {
                    onChange(!checked);
                    e.stopPropagation();
                }}
                icon={!checked ? "emptyHeart" : "fullHeart"}
            />
        </div>
    );
};
